import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import style from "../common.module.scss"
import CloseIcon from '../../../shared/icons/CloseIcon';
import EditIconNew from '../../../shared/icons/EditIconNew';
import PlusIcon from '../../../shared/icons/PlusIcon';
import MoreIcon from '../../../shared/icons/MoreIcon';
import { ORDER_STATUSES_DATA } from '../../../../mock';
import BallIcon from '../../../shared/icons/BallIcon';
import CancelApp from '../../../order/info/CancelApp';
import { File } from '../../../../services';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {t} from "i18next";

const OrdersInfoHeader = ({ item, setIsOpen, onForceUpdate, userType, companyId = "" }) => {
    const [isOpenDropdowns, setIsOpenDropdowns] = useState(false);
    const [isCancel, setCancelModal] = useState(false);
    const moreRef = useRef(null);
    const navigate = useNavigate()

    const shouldShowButton = () => {
      return (
        item?.status === "moderation" ||
        item?.status === "awaiting_payment" ||
        item?.status === "rejected" ||
        item?.status === "canceled"
      );
    };

    const handleDownloadClick = () => {
        setIsOpenDropdowns(false)
    };

    const handleClickOutside = (event) => {
        if (moreRef.current && !moreRef.current.contains(event.target)) {
            setIsOpenDropdowns(false);
        }
    };

    const downloadInvoice = async (orderId) => {
        toast.success('Запрос успешно выполнен');
        try {
          const response = await File.getDocPayment(orderId);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${item.number}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } catch (error) {
          console.error('Ошибка загрузки платежного документа:', error);
        }
    };

    useEffect(() => {
        if (isOpenDropdowns) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDropdowns]);

    return (
        <div className={cn(style.header_wrapper)}>
            <CloseIcon fill="#6D7885" width='24' height='24' onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
            <div className={style.header_text}>
                <div className={style.orders_title}>{item?.cityFromName} - {item?.cityToName}</div>
                <div className={style.orders_status} style={{ color: ORDER_STATUSES_DATA(t)[item?.status]?.color }}>
                    <BallIcon fill={ORDER_STATUSES_DATA(t)[item?.status]?.color} />
                    {ORDER_STATUSES_DATA(t)[item?.status]?.title || item?.status}
                </div>
            </div>
            {shouldShowButton() && (
                <EditIconNew 
                    style={{ cursor: 'pointer' }} 
                    onClick={() =>
                        navigate(userType === "Client" ? `/orders/edit/${item.id}` : `/expeditor/orders/edit/${item.id}`)
                    }
                />
            )}
            <button className={style.header_btn} onClick={() => navigate(userType === "Client" ? `/orders/copy/${item.id} ` : `/expeditor/orders/copy/${item.id}`)}>
                <PlusIcon /> {t ('copyOrder')}
            </button>
            <div className={style.header_more} ref={moreRef}>
                <MoreIcon onClick={() => { setIsOpenDropdowns(!isOpenDropdowns) }} />
                <div className={cn(style.header_dropdowns, { [style.header_dropdowns_open]: isOpenDropdowns })}>
                    {/* <div className={style.header_dropdowns_item} onClick={handleDownloadClick}>Отправить в черновик</div> */}
                    
                    {userType === "Expeditor" && item?.type === 1 && item?.isPublic && companyId === item?.companyId && (
                    <div className={cn(style.header_dropdowns_item)} onClick={() => downloadInvoice(item.id)}>
                        {t ('downloadInvoice')}
                    </div>
                    )}

                    {userType === "Client" && (
                    <div className={cn(style.header_dropdowns_item)} onClick={() => downloadInvoice(item.id)}>
                        {t ('downloadInvoice')}
                    </div>
                    )}

                    {shouldShowButton() && (
                        <div className={cn(style.header_dropdowns_item, style.header_dropdowns_reset)} onClick={() => setCancelModal(true)}>{t ('cancelOrder')}</div>
                    )}
                </div>
            </div>
            {isCancel &&
                <CancelApp
                    item={item}
                    onClose={() => setCancelModal(false)}
                    onUpdateData={() => onForceUpdate()}
                />
            }
        </div>
    );
};

export default OrdersInfoHeader;